import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppCardItem, ResponsiveAppBar, AppCardGrid } from "../../components-old/ComponentsIndex";
import { selectEmployee, selectUser, selectUserRoles } from "../../store/store-selector";
import HOME_TOP_BG from "../../assets/images/rentokil-home-top-bg.svg";
import { HomeDivContainer } from "./style.module";
import { UserRoles } from "../../AppConstants";

const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const employee = useSelector(selectEmployee);
  const userRoles = useSelector(selectUserRoles);

  const [allowedUserActions, setAllowedUserActions] = useState([]);


  useEffect(() => {
    let allowedUserActions = [];


    if (employee) {
      allowedUserActions.push(
        {
          title: t("home.quoteApprovalRoleTitle"),
          text: t("home.quoteApprovalRoleText"),
          displayButton: true,
          cardWidth: "30rem",
          paddingTop: "50px",
          buttonOnClick: () => {
            navigate("/quotelist");
          },
          buttonText: t("home.quoteApprovalRoleButtonText"),
        }
      );
    }

    //1002 for pricing admin, 1004 for viewer
    if (employee && userRoles && userRoles.some(item => item.UserRoleCode === UserRoles.PricingAdmin
      || item.UserRoleCode === UserRoles.Viewer)) {
      allowedUserActions.push({
        title: t("home.pricingConfigRoleTitle"),
        text: t("home.pricingConfigRoleText"),
        displayButton: true,
        cardWidth: "30rem",
        paddingTop: "50px",
        buttonOnClick: () => {
          navigate("/devicelist");
        },
        buttonText: t("home.pricingConfigRoleButtonText"),
      })
    }

    //1003 for pricing approver
    if (employee && userRoles && userRoles.some(item => item.UserRoleCode === UserRoles.PricingApprover)) {
      allowedUserActions.push({
        title: t("home.pricingApprovalRoleTitle"),
        text: t("home.pricingApprovalRoleText"),
        displayButton: true,
        cardWidth: "30rem",
        paddingTop: "50px",
        buttonOnClick: () => {
          navigate("/pricingchanges");
        },
        buttonText: t("home.pricingApprovalRoleButtonText"),
      })
    }

    //use 1001 for superadmin
    if (employee && userRoles && userRoles.some(item => item.UserRoleCode === UserRoles.SuperAdmin)) {
      allowedUserActions.push({
        title: t("home.userAccessManageRoleTitle"),
        text: t("home.userAccessManageRoleText"),
        displayButton: true,
        cardWidth: "30rem",
        paddingTop: "50px",
        buttonOnClick: () => {
          navigate("/userrolelist");
        },
        buttonText: t("home.userAccessManageRoleButtonText"),
      })
    }

    setAllowedUserActions(allowedUserActions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ResponsiveAppBar avatarUrl={user.userRecord.photoURL} userName={user.userRecord.displayName} />
      <HomeDivContainer divStyle={{ height: "calc(100vh - 64px)" }}>
        <HomeDivContainer
          divStyle={{
            background: `url(${HOME_TOP_BG}) no-repeat center / cover`,
            height: "50vh",
          }}
        >
          <AppCardItem
            title={t("home.welcomeCardTitle") + user.userRecord.displayName.split(" ")[0]}
            text={t("home.welcomeCardText")}
          />
        </HomeDivContainer>
        <div style={{ display: "flex", height: "calc(50vh - 64px)" }}>
          <AppCardGrid items={allowedUserActions} />
        </div>
      </HomeDivContainer>
    </>
  );
};

export default Home;
